export const workspaceContainerClassName = 'mx-auto w-full max-w-[92rem] px-4 sm:px-6 lg:px-8';

export interface WorkspaceContainerProps {
  as?: 'div' | 'main' | 'section';
  children: React.ReactNode;
  className?: string;
}

export function WorkspaceContainer({
  as: Component = 'div',
  children,
  className,
}: WorkspaceContainerProps): React.ReactElement {
  return (
    <Component className={classNames(workspaceContainerClassName, className)}>{children}</Component>
  );
}

function classNames(...values: Array<string | undefined>): string {
  return values.filter(Boolean).join(' ');
}
